import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { ENV } from '@hyper-inferno/hyper-base-ng';
import { SurveyListOption } from '@hyper-inferno/survey-elements-core';
import { IBotService } from '@hyper-inferno/survey-elements-core-ui';
import {
  ChatMessage,
  HandshakeResponse,
  SurveyResolverStartPayload,
} from '@hyper-inferno/survey-elements-core-utils';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SurveyBotWeb implements IBotService {
  getAttachmentUrl(
    surveyId: number,
    mediaPath: string,
  ): Promise<string | null> {
    return Promise.resolve(mediaPath);
  }
  validation_enabled = signal<boolean>(true);
  // survey_api_url = '/api/api';
  survey_api_url = inject(ENV).survey_api_url;
  consoleApi = inject(ENV).consoleApi;

  async handshake(
    payload: SurveyResolverStartPayload,
  ): Promise<HandshakeResponse> {
    try {
      return await firstValueFrom(
        this.http.post<HandshakeResponse>(
          `${this.survey_api_url}/survey-handshake/init`,
          payload,
        ),
      );
    } catch (error) {
      throw Error('Hand Shake Failed');
    }
  }
  http = inject(HttpClient);
  sendAnswerBot(message: ChatMessage): Promise<ChatMessage> {
    return firstValueFrom(
      this.http.post<ChatMessage>(
        `${this.survey_api_url}/interaction`,
        message, // Body only contains the ID
      ),
    );
  }
  async startSurveyTransaction(token: string): Promise<ChatMessage> {
    const headers = new HttpHeaders().set('x-handshake-token', `${token}`);

    return await firstValueFrom(
      this.http.post<ChatMessage>(
        `${this.survey_api_url}/start`,
        {}, // Body only contains the ID
        { headers }, // Token is in the header
      ),
    );
  }

  fetchAfmOptions(props: any, pageValue: any): Observable<SurveyListOption[]> {
    return this.http.post<SurveyListOption[]>(
      `${this.survey_api_url}/get-dynamic-options`,
      {
        props,
        page_value: pageValue,
      },
    );
  }
}
